import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useAuth } from '../../contexts/AuthContext';
import { useTranslation } from '../../i18n';
import NavigationBar from '../NavigationBar';
import ListCodes from '../ListCodes';
import Footer from '../Footer';
import './Dashboard.css';

const Dashboard = () => {
  const { state } = useAuth();
  const { t } = useTranslation();
  
  // Always show the same dashboard layout regardless of login status
  // The ListCodes component will handle getting keys from localStorage vs Supabase
  return (
    <>
      <Helmet>
        <title>Dashboard - SecurePaper App</title>
        <meta name="description" content="Manage your encrypted SecurePaper documents. View, create, and decrypt your secure paper codes from your dashboard." />
        <meta property="og:title" content="Dashboard - SecurePaper App" />
        <meta property="og:description" content="Manage your encrypted SecurePaper documents from your dashboard." />
        <meta property="og:url" content="https://app.securepaper.app/dashboard" />
        <link rel="canonical" href="https://app.securepaper.app/dashboard" />
      </Helmet>
      <NavigationBar />
      
      <div className="dashboard-container">
        <div className="container">
          <div className="dashboard-header">
            <h1>{t('dashboard.title')}</h1>
            {state.isLoggedIn ? (
              <p>{t('dashboard.welcomeBack', { email: state.user?.email })}</p>
            ) : (
              <p>{t('dashboard.subtitle')}</p>
            )}
          </div>
          
          <div className="quick-actions mb-4">
            <div className="row">
              <div className="col-md-6">
                <Link to="/create_encrypted_text" className="action-card">
                  <i className="fa fa-plus-circle" aria-hidden="true"></i>
                  <h4>{t('dashboard.createNew')}</h4>
                  <p>{t('dashboard.createNewDesc')}</p>
                </Link>
              </div>
              <div className="col-md-6">
                <Link to="/decrypt" className="action-card">
                  <i className="fa fa-qrcode" aria-hidden="true"></i>
                  <h4>{t('dashboard.scan')}</h4>
                  <p>{t('dashboard.scanDesc')}</p>
                </Link>
              </div>
            </div>
            <div className="template-shortcuts text-center mt-3">
              <small className="text-muted mr-2">{t('dashboard.popular')}</small>
              <Link to="/create_encrypted_text?template=seed-phrase" className="btn btn-sm btn-outline-secondary mr-2 mb-1">
                <i className="fa fa-coins" aria-hidden="true"></i> {t('templates.seed-phrase.name')}
              </Link>
              <Link to="/create_encrypted_text?template=2fa-codes" className="btn btn-sm btn-outline-secondary mr-2 mb-1">
                <i className="fa fa-mobile" aria-hidden="true"></i> {t('templates.2fa-codes.name')}
              </Link>
              <Link to="/create_encrypted_text?template=emergency-access" className="btn btn-sm btn-outline-secondary mb-1">
                <i className="fa fa-heartbeat" aria-hidden="true"></i> {t('templates.emergency-access.name')}
              </Link>
            </div>
          </div>

          {!state.isLoggedIn && (
            <div className="alert alert-info">
              <div className="d-flex align-items-center">
                <i className="fa fa-info-circle mr-2" aria-hidden="true"></i>
                <div className="flex-grow-1">
                  <strong>{t('dashboard.noAccountStrong')}</strong> {t('dashboard.noAccountInfo')}
                </div>
                <div>
                  <Link to="/signup" className="btn btn-sm btn-primary mr-2">{t('nav.signup')}</Link>
                  <Link to="/login" className="btn btn-sm btn-outline-primary">{t('nav.login')}</Link>
                </div>
              </div>
            </div>
          )}
          
          <ListCodes />
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default Dashboard;
